var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{ref:"box",staticClass:"box"},[_c('div',{ref:"marquee",staticClass:"marquee"},[_vm._v(_vm._s(_vm.text))]),_c('div',{ref:"copy",staticClass:"copy"})]),_c('div',{ref:"node",staticClass:"node"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }